import FloatingVue from 'floating-vue'
import { defineNuxtPlugin } from '#app'
import 'floating-vue/dist/style.css'
import '~/assets/css/tooltip-theme.css'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(FloatingVue, {
    // Global tooltip configuration
    themes: {
      tooltip: {
        // Default placement
        placement: 'right',
        // Offset distance from target
        distance: 6,
        // Arrow padding
        arrowPadding: 8,
        // Triggers
        triggers: ['hover', 'focus'],
        // Auto hide on click outside
        autoHide: true,
        // Delays
        delay: {
          show: 0,
          hide: 100,
        },
        // Overflow prevention
        overflowPadding: 10,
        // Dispose timeout
        disposeTimeout: 2000,
      },
    },
  })
})
